import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, Users, AlertCircle, BarChart2, FileText, Settings, 
  Leaf, Target, Truck, MessageSquare, Zap, DollarSign, 
  ChevronLeft, ChevronRight, FileText as TermsIcon, Shield, Info
} from 'lucide-react';
import logoImage from '../components/assets/logo.png';

const menuItems = [
  { name: 'Dashboard', icon: Home, path: '/' },
  { name: 'ESG', items: [
    { name: 'Environmental', icon: Leaf, path: '/environmental' },
    { name: 'Social', icon: Users, path: '/social' },
    { name: 'Governance', icon: AlertCircle, path: '/governance' },
  ]},
  { name: 'Tools', items: [
    { name: 'Analytics', icon: BarChart2, path: '/analytics' },
    { name: 'Reports', icon: FileText, path: '/reports' },
    { name: 'Goal Tracker', icon: Target, path: '/goals' },
  ]},
  { name: 'Management', items: [
    { name: 'Supply Chain', icon: Truck, path: '/supply-chain' },
    { name: 'Stakeholder Engagement', icon: MessageSquare, path: '/stakeholders' },
    { name: 'Carbon Accounting', icon: Zap, path: '/carbon-accounting' },
    { name: 'Risk Assessment', icon: AlertCircle, path: '/risk-assessment' },
    { name: 'Sustainable Finance', icon: DollarSign, path: '/sustainable-finance' },
  ]},
  { name: 'Settings', icon: Settings, path: '/settings' },
];

const Sidebar = () => {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const appVersion = "v1.0.0"; // Replace with your actual app version

  return (
    <div className={`bg-green-800 text-white p-4 transition-all duration-300 ${isCollapsed ? 'w-18' : 'w-64'} h-screen flex flex-col`}>
      <div className="flex items-center justify-between mb-6">
        {!isCollapsed && <img src={logoImage} alt="ESGrity.ai" className="h-9" />}
        <button onClick={() => setIsCollapsed(!isCollapsed)} className="p-1.5 rounded-full hover:bg-green-700">
          {isCollapsed ? <ChevronRight size={22} /> : <ChevronLeft size={22} />}
        </button>
      </div>
      <div className="flex-grow overflow-y-auto space-y-3">
        {menuItems.map((item) => (
          item.items ? (
            <div key={item.name} className="mb-3">
              {!isCollapsed && <div className="text-xs uppercase text-green-300 mb-1 px-2">{item.name}</div>}
              <div className="space-y-1">
                {item.items.map((subItem) => (
                  <Link
                    key={subItem.name}
                    to={subItem.path}
                    className={`flex items-center space-x-2 px-2 py-1.5 rounded-md transition-colors duration-200
                      ${location.pathname === subItem.path
                        ? 'bg-green-700 text-white'
                        : 'text-green-100 hover:bg-green-700/50 hover:text-white'}`}
                  >
                    {React.createElement(subItem.icon, { className: "h-4.5 w-4.5 flex-shrink-0" })}
                    {!isCollapsed && <span className="truncate text-sm">{subItem.name}</span>}
                  </Link>
                ))}
              </div>
            </div>
          ) : (
            <Link
              key={item.name}
              to={item.path}
              className={`flex items-center space-x-2 px-2 py-1.5 rounded-md transition-colors duration-200
                ${location.pathname === item.path
                  ? 'bg-green-700 text-white'
                  : 'text-green-100 hover:bg-green-700/50 hover:text-white'}`}
            >
              {React.createElement(item.icon, { className: "h-4.5 w-4.5 flex-shrink-0" })}
              {!isCollapsed && <span className="truncate text-sm">{item.name}</span>}
            </Link>
          )
        ))}
      </div>
      {!isCollapsed && (
        <div className="mt-auto pt-3 border-t border-green-700 text-xs">
          <div className="flex items-center justify-between text-green-300 px-2 py-1">
            <span className="flex items-center">
              <TermsIcon className="h-3.5 w-3.5 mr-1" /> Terms
            </span>
            <span className="flex items-center">
              <Shield className="h-3.5 w-3.5 mr-1" /> Privacy
            </span>
          </div>
          <div className="flex items-center justify-between text-green-400 px-2 py-1">
            <span>© 2024 ESGrity.AI</span>
            <span className="flex items-center">
              <Info className="h-3.5 w-3.5 mr-1" />
              {appVersion}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;